/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Session_Mic_Blocked_Firefox_2Inputs */



/**
* | output |
* | --- |
* | "Click the cross to lift the block." |
*
* @param {Practice_Session_Mic_Blocked_Firefox_2Inputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_mic_blocked_firefox_2 = /** @type {((inputs?: Practice_Session_Mic_Blocked_Firefox_2Inputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_Mic_Blocked_Firefox_2Inputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Klik op het kruisje om de blokkering op te heffen.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cliquez sur la croix pour lever le blocage.")
	return /** @type {LocalizedString} */ ("Click the cross to lift the block.")
});